import React, { useEffect, useState } from 'react';
import { Link, useParams, useNavigate } from 'react-router-dom';
import VoucherService from '../../api/services/VoucherService';
import MainPagetitle from '../../layouts/MainPagetitle';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { Modal, Button } from 'react-bootstrap';
import LogoAnimationLoader from '../Loading/LogoAnimationLoader';
const EditVoucher = () => {
  var imageUrl = process.env.REACT_APP_LARAVEL_IMAGE_URL + 'Voucher/';
  const params = useParams();
  const navigate = useNavigate();
  const [blogModal, setBlogModal] = useState(false);
  const [voucher, setBlog] = useState([]);
  const [file, setFile] = useState()
  const [Germanfile, setGermanFile] = useState()
  const [error, setError] = useState([]);
  const [description, setDescription] = useState("");
  const [Germandescription, setGermanDescription] = useState("");
  const [isLoading, setisloading] = useState(true);
  useEffect(() => {
    if (localStorage.getItem("admintoken")) {
      var id = params.id;
      getVoucherByID(id);
    }
    else {
      navigate('/')
    }
  }, []);

  const getVoucherByID = async (id) => {
    try {
      let voucherList = await VoucherService.show(id).json();
      setBlog(voucherList.data);
      setisloading(false);
    } catch (error) {
      if (error.name === 'HTTPError') {
        const errorJson = await error.response.json();
        setError(errorJson.message.substr(0, errorJson.message.lastIndexOf(".")))
      }
    }
  };

  const handleEditorChange = (e, editor) => {
    const data = editor.getData()
    setDescription(data);
  }
  const handleEditorChangeGerman = (e, editor) => {
    const data = editor.getData()
    setGermanDescription(data);
  }

  const onFileChange = (e) => {
    const fileReader = new FileReader()
    fileReader.readAsDataURL(e.target.files[0])
    fileReader.onload = () => {
      var voucher_image = fileReader.result
      setFile(voucher_image)
    }
  }
  const onFileChange1 = (e) => {
    const fileReader = new FileReader()
    fileReader.readAsDataURL(e.target.files[0])
    fileReader.onload = () => {
      var blog_image = fileReader.result
      setGermanFile(blog_image)
    }
  }

  const onSubmitForm = async (event) => {
    event.preventDefault();
    setError("")
    try {
      var userData = {

        "title": event.target.title.value,
        "de_title": event.target.de_title.value,
        "description": description,
        "de_description": Germandescription,
        "startprice": event.target.startprice.value,
        "endprice": event.target.endprice.value,
        "voucher_image": file ? file.split(',')[1] : "",
        "de_voucher_image": Germanfile ? Germanfile.split(',')[1] : ""
      }
      console.log(userData)
      let responseData = await VoucherService.update(params.id, userData).json()
      console.log(userData)
      if (responseData.status === true) {
        setBlogModal(true)
      }
    } catch (error) {
      if (error.name === 'HTTPError') {
        const errorJson = await error.response.json();
        setError(errorJson.message)
      }
    }

  };

  return (
    <>
      <MainPagetitle mainTitle="Edit Voucher" pageTitle={'Edit Voucher'} parentTitle={'Home'} />
      <div className="container-fluid">
        <form className="form-valide" onSubmit={onSubmitForm}>
          <div className="row">
            <div className="col-xl-12">
              <div className="card">
                <div className="card-header">
                  <h4 className="card-title">Edit Voucher</h4>
                </div>
                <div className="card-body">
                  <div className="row">
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >English Title<span className="text-danger">*</span></label>
                      <input type="text" className="form-control" name='title' id="val-username"
                        defaultValue={
                          voucher.title
                            ? voucher.title
                            : ''
                        } />
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >German Title<span className="text-danger">*</span></label>
                      <input type="text" className="form-control" name='de_title' id="val-username"
                        defaultValue={
                          voucher.de_title
                            ? voucher.de_title
                            : ''
                        }
                      />
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-number" className="form-label">  English Image <span className="text-danger">*</span></label>
                      {voucher.voucher_image ? <img className="img-drop-area" height={100} width={100} name="voucher_image" src={file ? file : imageUrl + voucher.voucher_image} alt='' /> : null}
                      <input type="file" className="form-control" name='voucher_image' id="val-number" onChange={onFileChange} />
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-number" className="form-label">  German Image <span className="text-danger">*</span></label>
                      {voucher.de_voucher_image ? <img className="img-drop-area" height={100} width={100} name="de_voucher_image" src={Germanfile ? Germanfile : imageUrl + voucher.de_voucher_image} alt='' /> : null}
                      <input type="file" className="form-control" name='de_voucher_image' id="val-number" onChange={onFileChange1} />
                    </div>

                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-number" className="form-label">  English Description <span className="text-danger">*</span></label>
                      <div className="custom-ekeditor">
                        <CKEditor
                          editor={ClassicEditor}
                          name="description"
                          data={voucher.description}
                          onChange={handleEditorChange}
                        />
                      </div>
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-number" className="form-label">  German Description <span className="text-danger">*</span></label>
                      <div className="custom-ekeditor">
                        <CKEditor
                          editor={ClassicEditor}
                          name="de_description"
                          data={voucher.de_description}
                          onChange={handleEditorChangeGerman}
                        />
                      </div>
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label className="form-label" >Start Price<span className="text-danger">*</span></label>
                      <input type="text" className="form-control" name='startprice' id="startprice"
                        defaultValue={
                          voucher.startprice
                            ? voucher.startprice
                            : ''
                        } />
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label className="form-label" >End Price<span className="text-danger">*</span></label>
                      <input type="text" className="form-control" name='endprice' id="endprice"
                        defaultValue={
                          voucher.endprice
                            ? voucher.endprice
                            : ''
                        } />
                    </div>

                  </div>
                  <h5 style={{ color: 'red' }}>{error}</h5>
                  <div>
                    <button type="submit" className="btn btn-primary me-1">Submit</button>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </form>
      </div>
      {isLoading && <LogoAnimationLoader />}
      <Modal centered className="mark-attendence" show={blogModal}>
        <Modal.Header>
          <Modal.Title>Update </Modal.Title>
          <Button variant="" className="btn-close" onClick={() => setBlogModal(false)}></Button>
        </Modal.Header>
        <Modal.Body>Update Voucher Successfully!!!.</Modal.Body>
        <Modal.Footer>
          <Link className="btn btn-primary" to={'/admin/vouchers'} variant="danger light" onClick={() => setBlogModal(false)}>Close</Link>
        </Modal.Footer>
      </Modal>
    </>
  );
};
export default EditVoucher;